import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Redirect } from 'react-router-dom';
import { resetLogin, loginAccount } from '../actions/login';

import Login from '../components/Login';

import { closeLoginModal, openForgotPasswordModal } from '../actions/auth';
import { getLogin } from '../selectors/login';

class LoginContainer extends Component {
  constructor(props) {
    super(props);

    this.checkIsReferred = this.checkIsReferred.bind(this);
    this.handleLogin = this.handleLogin.bind(this);
  }

  componentDidMount() {
    // login modal might be open on a previous page
    this.props.closeLoginModal();
    this.props.resetLogin();
  }

  handleLogin(values) {
    this.props.loginAccount({
      email: values.email.trim(),
      password: values.password.trim()
    });
  }

  checkIsReferred() {
    const { location } = this.props;

    if (
      location &&
      location.state &&
      location.state.from &&
      location.state.from.state
    ) {
      return location.state.from.state.isReferred;
    }
    return false;
  }

  render() {
    const isReferred = this.checkIsReferred();

    const { from } = this.props.location.state || {
      from: { pathname: '/discharge' }
    };

    return this.props.hasToken ? (
      <Redirect to={{ pathname: '/profile', state: { from } }} />
    ) : (
      <div>
        <Login
          {...this.props.loginProps}
          isReferred={isReferred}
          onOpenForgotPassword={this.props.openForgotPasswordModal}
          onSubmit={this.handleLogin}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    hasToken: state.auth.hasToken,
    loginProps: getLogin(state)
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      closeLoginModal,
      loginAccount,
      openForgotPasswordModal,
      resetLogin
    },
    dispatch
  );
}

LoginContainer.propTypes = {
  closeLoginModal: PropTypes.func.isRequired,
  hasToken: PropTypes.bool.isRequired,
  location: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  loginProps: PropTypes.shape(Login.propTypes).isRequired,
  loginAccount: PropTypes.func.isRequired,
  openForgotPasswordModal: PropTypes.func.isRequired,
  handleOpenSignUpModal: PropTypes.func,
  resetLogin: PropTypes.func.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginContainer);



// WEBPACK FOOTER //
// ./src/containers/LoginContainer.js